import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Menu, MenusResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class MenusDataService {

  private uri: string = `${environment.apiUrl}menus`;
  private cacheKey: string = 'menus.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getMenu(id: number): Observable<Menu|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getMenus(parameters: {[param: string]: string | string[]}): Observable<MenusResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addMenu(data: Menu): Observable<Menu|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addMenus(data: Menu[]): Observable<Menu[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateMenu(data: Menu): Observable<Menu|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateMenus(data: Menu[]): Observable<Menu[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchMenu(data: Menu): Observable<Menu|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchMenus(data: Menu[]): Observable<Menu[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteMenu(data: Menu): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteMenus(data: Menu[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((menu) => {
      ids.push(menu.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
